import styled from "styled-components";

export const ContainerCartComponent = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    max-width: 1240px;
    padding: 4.5rem 1rem 0 1rem;

    h1 {
        margin: 4rem 0;
    }

    section {
        max-width: 1024px;
    }
`;
